import AUNoticeModal from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/NoticeModal/AUNoticeModal';
import NZNoticeModal from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/NoticeModal/NZNoticeModal';

export { AUNoticeModal };
export { NZNoticeModal };
